/* eslint-disable react/jsx-no-undef */
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  NumberInput,
  NumberInputField,
  Select,
  SimpleGrid,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import axios from "axios";
import { SingleDatepicker } from "chakra-dayzed-datepicker";

import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ArquivoUpload } from "models/arquivo_upload";
import { CentroCusto } from "models/centro_custo_type";
import { ClientClassificationType } from "models/client_classification_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContasPagar } from "models/contas_pagar";
import { ContaFinanceiro } from "models/conta_financeiro";
import { FinanceCategoryType } from "models/finance_category";
import { LancamentoFinanceiro } from "models/lancamento_type";
import { OrcamentoDepto } from "models/orcamento_departamento";
import { PessoaType } from "models/person_type";
import { OptionType } from "models/select_mode";
import { SubFinanceType } from "models/sub_finance_category";
import { UsuarioModel } from "models/user_model";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  MdAdd,
  MdEdit,
  MdMail,
  MdPrint,
  MdSave,
  MdUpload
} from "react-icons/md";
import formatNumber from "views/admin/order/hooks/formatNumber";
import LancamentoTable from "../../contasReceber/components/LancamentoTable";

interface IContasPagarForm {
  show: boolean;
  showModal: (show: boolean) => void;
  accountSelected: ContasPagar;
  categoria: FinanceCategoryType[];
  centroCusto: CentroCusto[];
  fornecedor: PessoaType[];
  condicaoPagamento: CondicaoPagamento[];
  showFormPessoa: (show: boolean) => void;
  editPessoa: (item: PessoaType) => void;
  depto: ClientClassificationType[];
  save: (list: any) => void;
  selectedFornecedor: PessoaType;
  selectedCategoria: FinanceCategoryType;
  selectedCentroCusto: CentroCusto;
  selectedDepto: ClientClassificationType;
  selectedCondicaoPagamentos: CondicaoPagamento;
  changeFornecedor: (item: string) => void;
  changeCategoria: (item: string) => void;
  changeCentroCusto: (item: string) => void;
  changeCondicaoPagamento: (item: string) => void;
  changeDepto: (item: string) => void;
  changeInput: (value: any, type: string) => void;
  textColor: string;
  brandStars: string;
  uploadPictures: (list: any[]) => Promise<ArquivoUpload[]>;
  loading: boolean;
  getLink: (id: string) => void;
  changeSubCategoria: (item: string) => void;
  subcategoria: SubFinanceType[];
  selectedSubCategoria: SubFinanceType;
  itemList: LancamentoFinanceiro[];
  addRowItem: (item: LancamentoFinanceiro) => void;
  editRowItem: (item: LancamentoFinanceiro) => void;
  deleteRow: (item: LancamentoFinanceiro) => void;
  user: UsuarioModel;
  generateParcela: (
    item: string,
    vencimento: Date,
    valor: number,
    fornecedor: string,
    tipoRecebimento: string
  ) => void;
  changeConta: (item: string) => void;
  contaFinanceiroLista: ContaFinanceiro[];
  selectedConta: ContaFinanceiro;
  changeUser: (item: string) => void;
  selectedUser: UsuarioModel;
  users: UsuarioModel[];
  changeDeptoOrcamento: (item: string) => void;
  selectedDeptoOrcamento: OrcamentoDepto;
  listDepto: OrcamentoDepto[];
  filiais: PessoaType[];
  onChangeFilial: (item: string) => void;
  selectedFilial: PessoaType
}

const ContasPagarForm = ({
  accountSelected,
  show,
  showModal,
  categoria,
  centroCusto,
  condicaoPagamento,
  depto,
  editPessoa,
  fornecedor,
  save,
  showFormPessoa,
  selectedFornecedor,
  changeFornecedor,
  textColor,
  brandStars,
  changeCategoria,
  changeCentroCusto,
  changeCondicaoPagamento,
  changeDepto,
  selectedCategoria,
  selectedCentroCusto,
  selectedCondicaoPagamentos,
  selectedDepto,
  changeInput,
  loading,
  getLink,
  changeSubCategoria,
  subcategoria,
  selectedSubCategoria,
  addRowItem,
  deleteRow,
  editRowItem,
  itemList,
  user,
  generateParcela,
  changeConta,
  contaFinanceiroLista,
  selectedConta,
  changeUser,
  selectedUser,
  users,
  changeDeptoOrcamento,
  listDepto,
  selectedDeptoOrcamento,
  filiais,
  onChangeFilial,
  selectedFilial,
}: IContasPagarForm) => {
  const [arquivoLista, setArquivoLista] = useState<any[]>([]);

  const onDrop = useCallback(
    (acceptedFiles: any) => {
      const list = [...arquivoLista];
      acceptedFiles?.forEach((file: { path: string }) => {
        const existe = list.find((f) => f.path === file?.path);
        if (!existe) {
          list.push(file);
        }
      });
      setArquivoLista(list);
    },

    [arquivoLista]
  );

  const removeFile = async (arquivo: any) => {
    if (arquivo?.remote) {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + "/  contas-pagar/arquivo/" + arquivo?.id
      );
      console.log(response.data);
    }
    const newFile = arquivoLista.filter((arq) => arq !== arquivo);
    setArquivoLista(newFile);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const bg = useColorModeValue("gray.100", "navy.700");
  const borderColor = useColorModeValue("secondaryGray.100", "whiteAlpha.100");

  useEffect(() => {
    if (accountSelected?.id !== undefined) {
      changeFornecedor(accountSelected?.pessoaId);
      changeCategoria(accountSelected?.categoriaLancamentoId);
      changeCondicaoPagamento(accountSelected?.condicaoPagamentoId);
      changeDepto(accountSelected?.centroCusto?.departamentoId);
      changeCentroCusto(accountSelected?.centroCustoId);
      changeSubCategoria(accountSelected?.subCategoriaLancamentoId);
      changeConta(accountSelected?.contaFinanceiroId);
      changeUser(accountSelected?.usuarioId);
      changeDeptoOrcamento(accountSelected?.orcamentoDeptoId);
      onChangeFilial(accountSelected?.empresaSaiadaId);
      const newArray: any[] = [];
      accountSelected?.ContasPagarArquivo?.forEach((arquivo) => {
        const itemData = {
          name: arquivo?.arquivo?.fileName,
          remote: true,
          id: arquivo.arquivo.id,
        };
        newArray.push(itemData);
      });

      setArquivoLista(newArray);
    } else {
      setArquivoLista([]);
    }
  }, [
    accountSelected,
    changeCategoria,
    changeCentroCusto,
    changeCondicaoPagamento,
    changeDepto,
    changeFornecedor,
    changeSubCategoria,
    changeConta,
    changeUser,
    changeDeptoOrcamento,
    onChangeFilial
  ]);

  return (
    <Box w={"100%"} h={"100%"}>
      <Box
        px="0px"
        mb="16px"
        mt="0px"
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={4}>
          <Button
            leftIcon={<MdMail />}
            colorScheme="brand"
            size={"sm"}
            variant="solid"
          >
            Enviar
          </Button>
          <Button
            leftIcon={<MdPrint />}
            colorScheme="brand"
            size={"sm"}
            variant="solid"
          >
            Imprimir
          </Button>

          <Button
            leftIcon={<MdSave />}
            colorScheme="brand"
            size={"sm"}
            variant="solid"
            isLoading={loading}
            onClick={() => save(arquivoLista)}
          >
            Salvar
          </Button>
        </Stack>
      </Box>
      <SimpleGrid columns={4} spacing={4} mt={24}>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Empresa Saída/Filial
          </FormLabel>

          <Select size="md"
            onChange={(e) => onChangeFilial(e.target.value)}
            defaultValue={accountSelected?.empresaSaiadaId}
          >
            <option value={"0"}>NENHUMA</option>
            {filiais?.map((item) => (
              <option value={item.id}>{item.nome}</option>
            ))}
          </Select>

        </FormControl>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Favorecido<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <Box w={"76%"}>
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size={"md"}
                onChange={(e) => {
                  changeFornecedor(e.value);
                  if (
                    accountSelected?.valor &&
                    accountSelected?.vencimento &&
                    selectedCondicaoPagamentos &&
                    accountSelected?.tipoRecebimento
                  ) {
                    generateParcela(
                      selectedCondicaoPagamentos.id,
                      accountSelected.vencimento,
                      accountSelected?.valor,
                      e.value,
                      accountSelected?.tipoRecebimento
                    );
                  }
                }}
                placeholder="Buscar..."
                isDisabled={false}
                name={"fornecedor"}
                value={{
                  label: fornecedor?.find(
                    (f) => f.id === selectedFornecedor?.id
                  )?.nome,
                  value: selectedFornecedor?.id,
                }}
                options={fornecedor?.map((item) => {
                  return {
                    label: item?.nome,
                    value: item?.id,
                  };
                })}
              />
            </Box>
            <IconButton
              colorScheme="brand"
              variant="solid"
              mt={-10}
              borderRadius={8}
              mr={12}
              size={"md"}
              icon={<MdAdd />}
              onClick={() => showFormPessoa(true)}
              float={"right"}
              aria-label={"Adicionar Cliente"}
            />
            <IconButton
              colorScheme="brand"
              variant="solid"
              size={"md"}
              mt={-10}
              ml={0}
              borderRadius={8}
              icon={<MdEdit />}
              onClick={() => {
                editPessoa(selectedFornecedor);
              }}
              float={"right"}
              aria-label={"Editar Contato"}
            />
          </Box>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Departamento<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => changeDepto(e.value)}
              placeholder="Buscar..."
              isDisabled={false}
              name={"fornecedor"}
              value={{
                label: depto?.find((f) => f.id === selectedDepto?.id)?.nome,
                value: selectedDepto?.id,
              }}
              options={depto?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
            />
          </Box>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Centro de Custos<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => changeCentroCusto(e.value)}
              placeholder="Buscar..."
              isDisabled={false}
              name={"fornecedor"}
              value={{
                label: centroCusto?.find(
                  (f) => f.id === selectedCentroCusto?.id
                )?.nome,
                value: selectedCentroCusto?.id,
              }}
              options={centroCusto?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
            />
          </Box>
        </FormControl>
      </SimpleGrid>
      <SimpleGrid columns={4} spacing={4} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Usuário Responsável
          </FormLabel>

          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            placeholder="Busque o Responsável"
            isRequired={true}
            name={"executivo"}
            onChange={(e) => {
              changeUser(e.value);
            }}
            options={users?.map((item) => {
              return {
                label: item.nome,
                value: item.id,
              };
            })}
            defaultValue={{
              label: selectedUser?.nome,
              value: selectedUser?.id,
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Plano de Contas<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => changeDeptoOrcamento(e.value)}
              placeholder="Buscar..."
              isDisabled={false}
              name={"planoContas"}
              value={{
                label: listDepto?.find(
                  (f) => f.id === selectedDeptoOrcamento?.id
                )?.descricao,
                value: selectedDeptoOrcamento?.id,
              }}
              options={listDepto?.map((item) => {
                return {
                  label: item?.descricao,
                  value: item?.id,
                };
              })}
            />
          </Box>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Vencimento Original
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={
              accountSelected?.vencOriginal !== undefined
                ? new Date(accountSelected?.vencOriginal)
                : new Date()
            }
            onDateChange={(date: any) => {
              changeInput(date, "vencOriginal");
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Vencimento
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",

              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={
              accountSelected?.vencimento !== undefined
                ? new Date(accountSelected?.vencimento)
                : new Date()
            }
            minDate={new Date(moment(new Date()).format("YYYY-MM-DD"))}
            onDateChange={(date: any) => {
              changeInput(date, "vencimento");
              if (
                selectedCondicaoPagamentos &&
                accountSelected?.valor &&
                selectedFornecedor &&
                accountSelected?.tipoRecebimento
              ) {
                generateParcela(
                  selectedCondicaoPagamentos.id,
                  date,
                  accountSelected?.valor,
                  selectedFornecedor?.id,
                  accountSelected?.tipoRecebimento
                );
              }
            }}
          />
        </FormControl>
      </SimpleGrid>
      <SimpleGrid columns={6} spacing={4} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Valor
          </FormLabel>
          <NumberInput
            precision={2}
            min={0}
            onBlur={(e) => {
              if (
                selectedCondicaoPagamentos &&
                accountSelected.vencimento &&
                selectedFornecedor &&
                accountSelected?.tipoRecebimento
              ) {
                generateParcela(
                  selectedCondicaoPagamentos.id,
                  accountSelected.vencimento,
                  Number(e.target.value),
                  selectedFornecedor?.id,
                  accountSelected?.tipoRecebimento
                );
              }
            }}
            onChange={(e: string) => {
              changeInput(Number(e), "valor");
            }}
            defaultValue={accountSelected?.valor}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Número do Documento
          </FormLabel>
          <NumberInput
            min={0}
            onChange={(e: string) => {
              changeInput(e, "numDocumento");
            }}
            defaultValue={accountSelected?.numDocumento}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Origem
          </FormLabel>

          <Select
            size="md"
            onChange={(e) => changeInput(e.target.value, "origem")}
            defaultValue={accountSelected?.origem}
          >
            <option value={"0"}>SELECIONE A ORIGEM</option>
            <option value={"1"}>AVULSO</option>
            <option value={"2"}>PROJETO</option>
          </Select>
        </FormControl>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Data de Emissão
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={
              accountSelected?.dataEmissao !== undefined
                ? new Date(accountSelected?.dataEmissao)
                : new Date()
            }
            onDateChange={(date: any) => {
              changeInput(date, "dataEmissao");
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Competência
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={
              accountSelected?.competencia !== undefined
                ? new Date(accountSelected?.competencia)
                : new Date()
            }
            onDateChange={(date: any) => {
              changeInput(date, "competencia");
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Dia Vencimento
          </FormLabel>
          <NumberInput
            min={0}
            onChange={(e: string) => {
              changeInput(e, "parcelaVencimento");
            }}
            isDisabled={true}
            value={accountSelected?.parcelaVencimento}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>
      </SimpleGrid>
      <SimpleGrid columns={5} spacing={4} mt={8}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Conta para Baixa<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => {
                changeConta(e.value);
              }}
              placeholder="Buscar..."
              isDisabled={false}
              name={"contaFinanceiroLista"}
              defaultValue={{
                label: contaFinanceiroLista?.find(
                  (f) => f.id === selectedConta?.id
                )?.descricao,
                value: selectedConta?.id,
              }}
              options={contaFinanceiroLista?.map((item) => {
                return {
                  label: item?.descricao,
                  value: item?.id,
                };
              })}
            />
          </Box>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Forma de Pagamento<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => {
                changeCondicaoPagamento(e.value);
                if (accountSelected?.valor > 0) {
                  generateParcela(
                    e.value,
                    accountSelected?.vencimento,
                    accountSelected?.valor,
                    selectedFornecedor?.id,
                    accountSelected?.tipoRecebimento
                  );
                }
              }}
              placeholder="Buscar..."
              isDisabled={false}
              name={"condicaoPagamento"}
              defaultValue={{
                label: condicaoPagamento?.find(
                  (f) => f.id === selectedCondicaoPagamentos?.id
                )?.nome,
                value: selectedCondicaoPagamentos?.id,
              }}
              options={condicaoPagamento?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
            />
          </Box>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Tipo de Pagamento
          </FormLabel>

          <Select
            size="md"
            onChange={(e) => {
              changeInput(e.target.value, "tipoRecebimento");
              generateParcela(
                selectedCondicaoPagamentos.id,
                accountSelected.vencimento,
                accountSelected?.valor,
                selectedFornecedor?.id,
                e.target.value
              );
            }}
            defaultValue={accountSelected?.tipoRecebimento}
          >
            <option value={"0"}>SELECIONE O TIPO DE PAGAMENTO</option>
            <option value={"1"}>BOLETO</option>
            <option value={"2"}>CHEQUE</option>
            <option value={"3"}>CARTÃO</option>
            <option value={"4"}>DINHEIRO</option>
            <option value={"5"}>DEPÓSITO</option>
            <option value={"6"}>DÉBITO EM CONTA</option>
            <option value={"7"}>FATURA</option>
            <option value={"8"}>ARRECADAÇÃO/RECEBIMENTO</option>
            <option value={"9"}>TRANSFÊRENCIA</option>
            <option value={"10"}>PIX</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Categoria Financeira<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => changeCategoria(e.value)}
              placeholder="Buscar..."
              isDisabled={false}
              name={"categoria"}
              defaultValue={{
                label: categoria?.find(
                  (f) => f.id === selectedCategoria?.id
                )?.nome,
                value: selectedCategoria?.id,
              }}
              options={categoria?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
            />
          </Box>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            SubCategoria Financeira<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => changeSubCategoria(e.value)}
              placeholder="Buscar..."
              isDisabled={false}
              name={"subcategoria"}
              value={{
                label: selectedCategoria?.SubCategoriaLancamento?.find(
                  (f) => f.id === selectedSubCategoria?.id
                )?.nome,
                value: selectedSubCategoria?.id,
              }}
              options={selectedCategoria?.SubCategoriaLancamento?.map(
                (item) => {
                  return {
                    label: item?.nome,
                    value: item?.id,
                  };
                }
              )}
            />
          </Box>
        </FormControl>
      </SimpleGrid>
      <SimpleGrid spacing={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            mt={4}
            color={textColor}
          >
            Histórico<Text color={brandStars}>*</Text>
          </FormLabel>
          <Textarea
            defaultValue={accountSelected?.historico}
            fontSize="sm"
            height={200}
            ms={{ base: "0px", md: "0px" }}
            placeholder="Preencha o Histórico"
            onBlur={(e) => {
              changeInput(e.target.value, "historico");
            }}
            fontWeight="500"
            size="md"
          />
        </FormControl>
      </SimpleGrid>

      <Text
        mt={8}
        fontSize={18}
        color={"#422AFB"}
        fontWeight={"bold"}
        mb={4}
      >
        Lançamentos -{" "}
        {formatNumber(
          itemList.reduce((value, acc) => Number(acc.valor) + value, 0)
        )}
      </Text>
      <LancamentoTable
        itemList={itemList}
        addRowItem={addRowItem}
        editRowItem={editRowItem}
        deleteRow={deleteRow}
        borderColor={borderColor}
        textColor={textColor}
        selectedCliente={selectedFornecedor}
        user={user}
        tipo={false}
      />

      <Flex
        align="center"
        justify="center"
        bg={bg}
        mt={4}
        border="1px dashed"
        borderColor={borderColor}
        borderRadius="16px"
        w="100%"
        h={200}
        minH="100%"
        cursor="pointer"
        {...getRootProps({ className: "dropzone" })}
      >
        <input {...getInputProps()} />
        <Button variant="no-effects" leftIcon={<MdUpload />}>
          Enviar Arquivos
        </Button>
      </Flex>
      <Table variant="striped" color="gray.500" mb="24px" mt="12px">
        <Thead>
          <Tr>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #ARQUIVO
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #OPÇÕES
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {arquivoLista?.map((arquivo) => (
            <Tr>
              {arquivo?.remote !== undefined ? (
                <Td>
                  <a
                    href={process.env.REACT_APP_API_URL + `/arquivo/${arquivo?.id}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                    }}
                  >
                    {arquivo?.name}
                  </a>
                </Td>
              ) : (
                <Td>{arquivo?.name}</Td>
              )}
              <Td>
                <Button
                  onClick={() => {
                    removeFile(arquivo);
                  }}
                  colorScheme="red"
                  variant="ghost"
                  ml="1"
                >
                  Excluir
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};
export default ContasPagarForm;
